var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540.78,
    height: 574.437,
    viewBox: "0 0 540.78 574.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6dc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-value-investing-strategy-2705436",
    transform: "translate(-28.879 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(28.879 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M55.283,449.461H492.255c19.292,0,36.1-13.328,41.836-33.172l9.712-33.742a8.974,8.974,0,0,0-8.625-11.456H514.861V17.358H472.192V35.309H496.91V371.091H50.612V35.309H372.768V17.358H32.66V371.091H12.351a8.974,8.974,0,0,0-8.625,11.456l9.712,33.75C19.17,436.133,35.982,449.461,55.283,449.461Zm177.68-60.366h81.6c-.288.9,1.778,12.205-8.7,12.205H241.658a8.7,8.7,0,0,1-8.7-8.691v-3.515Zm-17.951,0v3.515a26.676,26.676,0,0,0,26.646,26.642h64.214a26.676,26.676,0,0,0,26.646-26.642v-3.515l190.74-.053-6.416,22.277c-3.488,12.074-13.367,20.191-24.586,20.191H55.283c-11.219,0-21.107-8.117-24.6-20.182l-6.416-22.285Z",
    transform: "translate(-3.375 124.976)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M342.3,21.61H10.892v295.3H416.738V21.61H383.8V39.561h14.988v259.4H28.843V39.561H342.3Z",
    transform: "translate(56.575 158.888)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 17.951,
    height: 44.952,
    transform: "translate(109.977 389.079)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 17.951,
    height: 94.748,
    transform: "translate(152.857 339.284)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 17.951,
    height: 78.151,
    transform: "translate(195.736 355.881)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 17.951,
    height: 111.345,
    transform: "translate(238.616 322.687)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 17.951,
    height: 94.748,
    transform: "translate(281.495 339.284)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 17.951,
    height: 144.543,
    transform: "translate(324.374 289.488)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 17.951,
    height: 161.139,
    transform: "translate(367.254 272.892)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M45.506,55.722,58.2,68.414,77.481,49.13V329.687H95.433V49.128l19.292,19.287,12.691-12.692L86.457,14.771Z",
    transform: "translate(332.644 104.344)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M280.434,72.14l2.875-42.507-42.59-2.669L239.6,44.88l10.643.666L220.583,69.595A25.262,25.262,0,0,0,207.8,65.978a25.537,25.537,0,0,0-18.205,7.7L147.529,55.116c.015-.368.112-.7.112-1.076a25.577,25.577,0,0,0-51.154,0,25.949,25.949,0,0,0,1.326,8.074L52.363,98.991a25.257,25.257,0,0,0-12.622-3.47A25.575,25.575,0,1,0,65.309,121.1a25.255,25.255,0,0,0-1.5-8.286L109.2,75.989a25.144,25.144,0,0,0,31.35-4.326l41.82,18.46c-.026.48-.147.944-.147,1.428A25.573,25.573,0,1,0,232,83.448L263.4,57.992l-.879,12.939ZM39.741,128.719a7.624,7.624,0,1,1,7.617-7.621A7.63,7.63,0,0,1,39.741,128.719Zm76.309-69.924a7.377,7.377,0,0,1-1.613-4.755,7.626,7.626,0,0,1,15.251,0C129.69,61.272,120.217,63.871,116.051,58.795ZM207.8,99.172a7.621,7.621,0,1,1,7.617-7.621A7.63,7.63,0,0,1,207.8,99.172Z",
    transform: "translate(82.675 201.589)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M98.786,1.5A54.82,54.82,0,1,0,153.6,56.322,54.888,54.888,0,0,0,98.786,1.5Zm0,91.688a36.869,36.869,0,1,1,36.866-36.866A36.912,36.912,0,0,1,98.786,93.188Z",
    transform: "translate(320.314 -1.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 22.088,
    height: 17.951,
    transform: "translate(58.351 526.294)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 22.08,
    height: 17.951,
    transform: "translate(102.887 526.294)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 22.08,
    height: 17.951,
    transform: "translate(147.423 526.294)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M69.247,28.047h-.2V15.315a21.86,21.86,0,0,1,9.686,3.93l4.4-6.232A28.315,28.315,0,0,0,69.043,7.932V4.478H64.709V7.865a16.584,16.584,0,0,0-10.668,4.062,12.375,12.375,0,0,0-4.1,9.585q0,5.858,3.559,8.839T64.709,35.16V48.3A23.527,23.527,0,0,1,52.99,42.409L48.046,48.3a29.425,29.425,0,0,0,16.663,7.38v4.944h4.334V55.75q6.909-.339,11.108-4.065a12.3,12.3,0,0,0,4.2-9.652q0-5.924-3.657-9.042T69.247,28.047Zm-4.538-1.218a13.719,13.719,0,0,1-5.148-2.541A4.772,4.772,0,0,1,58.207,20.7a4.856,4.856,0,0,1,1.725-3.792,8.115,8.115,0,0,1,4.777-1.8Zm9.484,19.777a9.46,9.46,0,0,1-5.148,1.9V36.312A14.733,14.733,0,0,1,74.6,38.919a5.227,5.227,0,0,1-.405,7.687Z",
    transform: "translate(352.905 22.253)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestment);
export default __webpack_public_path__ + "static/media/investment.9f020ede5fef795e3ae62cdef91389c1.svg";
export { ForwardRef as ReactComponent };